import { useEffect, useRef } from "react";
import { disablePageScroll, enablePageScroll } from "scroll-lock";
function useScrollLock(enabled = true, ref) {
    const disabledRef = useRef(false);
    useEffect(() => {
        var _a;
        if (enabled && !disabledRef.current) {
            disablePageScroll((_a = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _a !== void 0 ? _a : undefined);
            disabledRef.current = true;
        }
        return () => {
            var _a;
            if (disabledRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                enablePageScroll((_a = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _a !== void 0 ? _a : undefined);
                disabledRef.current = false;
            }
        };
    }, [enabled, ref, disabledRef]);
}
export default useScrollLock;
//# sourceMappingURL=use-scroll-lock.js.map